import { createFileRoute } from '@tanstack/react-router';

import { ClubManageEmployerPage } from '@/features/work/pages/club-manage-employer-page/ClubManageEmployerPage';
import { redirectUnauthenticated } from '@/shared/helper/redirectUnauthenticated';

export const Route = createFileRoute('/clubOwner/$id/employer/$workItemId')({
  beforeLoad: ({ context }) => {
    redirectUnauthenticated(context);
  },
  component: ClubManageEmployerPage
});
